import { Col, Modal as ModalAntD, Row, TimePicker } from 'antd';
import { ErrorMessage, Formik } from 'formik';
import moment from 'moment';

import * as S from './styled';

import {} from '@ant-design/icons';
import { offset } from '../../../utils/dates';
import SetPricingPageForm from '../SetPricingPageForm';
import {
  maskPercent,
  SetPricingPageFormValues,
} from '../SetPricingPageForm/SetPricingPageForm';

const Modal: any = ModalAntD;

export interface DynamicPricingModalConfig {
  visible: boolean;
  value?: SetPricingPageFormValues | null;
}

interface DynamicPricingConfigPeriodModalProps {
  dynamicPricingConfigModal: DynamicPricingModalConfig;
  dynamicPricingPeriods: SetPricingPageFormValues[];
  dayOfWeek: string;
  setDynamicPricingConfigModal: (value: DynamicPricingModalConfig) => void;
  setDynamicPricingPeriods: (dynamicPricingPeriod: any) => void;
  startDate: string;
  endDate?: string;
}

const DynamicPricingConfigPeriodModal = ({
  dynamicPricingConfigModal,
  dynamicPricingPeriods,
  dayOfWeek,
  setDynamicPricingConfigModal,
  setDynamicPricingPeriods,
  startDate,
  endDate,
}: DynamicPricingConfigPeriodModalProps) => {
  const onSubmit = (values: any) => {
    setDynamicPricingPeriods((prevState) => {
      const existingItemIndex = prevState.findIndex(
        (item) => item.id === values.id,
      );

      if (existingItemIndex !== -1) {
        const updatedPeriods = [...prevState];
        updatedPeriods[existingItemIndex] = {
          ...values,
          id: prevState[existingItemIndex].id,
          dayOfWeek,
          general: false,
        };

        return updatedPeriods;
      } else {
        return [
          ...prevState,
          {
            ...values,
            id: Math.random() * 3,
            dayOfWeek,
            general: false,
            startDate,
            endDate,
          },
        ];
      }
    });

    setDynamicPricingConfigModal({ visible: false, value: null });
  };

  return (
    <Modal
      visible={dynamicPricingConfigModal.visible}
      title=''
      footer={null}
      okText='Salvar configuração'
      width={'50%'}
      onCancel={() =>
        setDynamicPricingConfigModal({ visible: false, value: null })
      }
    >
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        validate={(values) => {
          const errors: any = {};

          const filteredDynamicPricingPeriods = dynamicPricingPeriods.filter(
            (dynamicPricingPeriod) =>
              dynamicPricingPeriod.id !== values.id &&
              dynamicPricingPeriod.dayOfWeek === dayOfWeek,
          );

          filteredDynamicPricingPeriods.forEach((dynamicPricingPeriod) => {
            if (
              dynamicPricingPeriod.startTimeGMT === values.startTimeGMT ||
              dynamicPricingPeriod.endTimeGMT === values.startTimeGMT
            ) {
              errors.startTimeGMT =
                'Ja existe um período de tempo iniciando e terminando neste horário';

              return;
            }

            if (
              dynamicPricingPeriod.endTimeGMT === values.endTimeGMT ||
              dynamicPricingPeriod.startTimeGMT === values.endTimeGMT
            ) {
              errors.endTimeGMT =
                'Ja existe um período de tempo iniciando e terminando neste horário';
            }
          });

          if (values.startTimeGMT === values.endTimeGMT) {
            errors.startTimeGMT =
              'Os campos de hora de início e de término devem ser diferentes';
            errors.endTimeGMT =
              'Os campos de hora de início e de término devem ser diferentes';
          }

          const parsedDateStartTime = moment
            .utc(values.startTimeGMT, 'HH:mm:ss')
            .utcOffset(offset)
            .format('HH:mm:ss');

          const parsedDateEndTime = moment
            .utc(values.endTimeGMT, 'HH:mm:ss')
            .utcOffset(offset)
            .format('HH:mm:ss');

          if (parsedDateStartTime > parsedDateEndTime) {
            errors.startTimeGMT =
              'O campo de hora de início não pode ser maior que o de término';
          }

          if (!values.startTimeGMT)
            errors.startTimeGMT = 'O campo hora de início é obrigatório.';

          if (!values.endTimeGMT)
            errors.endTimeGMT = 'O campo hora de termino é obrigatório.';

          if (!values.durationPrice && !values.kwhPrice) {
            errors.durationPrice =
              'É necessário definir ou o preço por duração ou preço por kWh';
            errors.kwhPrice =
              'É necessário definir ou o preço por duração ou preço por kWh';
          }

          if (values.isCustomIdleTimeEnabled === undefined) {
            if(values.customIdleTime != 0 || values.customIdleTime != ''){
              if ((values.customIdleTime < 1 || values.customIdleTime > 60)) {
                errors.customIdleTime = 'Tempo deve ser entre 1 e 60 minutos';
              }
            }
          } else {
            if ((values.customIdleTime < 1 || values.customIdleTime > 60) && values.isCustomIdleTimeEnabled) {
              errors.customIdleTime = 'Tempo deve ser entre 1 e 60 minutos';
            }
          }

          return errors;
        }}
        initialValues={{
          servicePrice: dynamicPricingConfigModal?.value?.servicePrice || '',
          kwhPrice: dynamicPricingConfigModal?.value?.kwhPrice || '',
          durationPrice: dynamicPricingConfigModal?.value?.durationPrice || '',
          operationFee: maskPercent(dynamicPricingConfigModal?.value?.operationFee),
          taxes: maskPercent(dynamicPricingConfigModal?.value?.taxes),
          idleTimePrice: dynamicPricingConfigModal?.value?.idleTimePrice || '',
          reservePrice: dynamicPricingConfigModal?.value?.reservePrice || '',
          moneyPerKilowattCost:
            dynamicPricingConfigModal?.value?.moneyPerKilowattCost || '',
          startTimeGMT: dynamicPricingConfigModal?.value?.startTimeGMT || '',
          endTimeGMT: dynamicPricingConfigModal?.value?.endTimeGMT || '',
          id: dynamicPricingConfigModal?.value?.id || Math.random() * 3,
          everyDayOfWeek: false,
          customIdleTime: dynamicPricingConfigModal?.value?.customIdleTime || '',
          isCustomIdleTimeEnabled: dynamicPricingConfigModal?.value?.isCustomIdleTimeEnabled || undefined,
        }}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, setFieldValue, values }) => {
          return (
            <>
              <Row gutter={16}>
                <Col md={16} xs={16} sm={16} lg={8}>
                  <S.FieldWrapper>
                    <S.Label>Hora de início</S.Label>

                    <TimePicker
                      onChange={(e) =>
                        setFieldValue(
                          'startTimeGMT',
                          moment.utc(e).format('HH:mm:ss'),
                        )
                      }
                      name='startTimeGMT'
                      placeholder=''
                      value={
                        values.startTimeGMT
                          ? moment
                              .parseZone(values.startTimeGMT, 'HH:mm:ss')
                              .utcOffset(offset)
                          : null
                      }
                      style={{ width: '100%' }}
                    />

                    <ErrorMessage
                      name='startTimeGMT'
                      component={S.MessageBox}
                    />
                  </S.FieldWrapper>
                </Col>

                <Col md={16} xs={16} sm={16} lg={8}>
                  <S.FieldWrapper>
                    <S.Label>Hora de término</S.Label>

                    <TimePicker
                      onChange={(e) =>
                        setFieldValue(
                          'endTimeGMT',
                          moment.utc(e).format('HH:mm:ss'),
                        )
                      }
                      name='endTimeGMT'
                      placeholder=''
                      value={
                        values.endTimeGMT
                          ? moment
                              .parseZone(values.endTimeGMT, 'HH:mm:ss')
                              .utcOffset(offset)
                          : null
                      }
                      style={{ width: '100%' }}
                    />

                    <ErrorMessage name='endTimeGMT' component={S.MessageBox} />
                  </S.FieldWrapper>
                </Col>
              </Row>
              
              <Row style={{ marginBottom: '20px' }}>
                <SetPricingPageForm
                  dayOfWeek={dayOfWeek}
                  loading={false}
                  isException={false}
                  />
              </Row>

              <Row>
                <S.Button
                  onClick={() => {
                    handleSubmit();
                  }}
                  size='large'
                  type='primary'
                  style={{ position: 'absolute', bottom: 16, right: 24 }}
                >
                  Salvar configuração
                </S.Button>
              </Row>

            </>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default DynamicPricingConfigPeriodModal;
